<template>
  <fragment>
    <v-form @submit.prevent="filterDetailedSalesByEvent" class="search-forms">
      <v-row class="align-center">
        <v-col cols="12" md="3" sm="4">
          <BaseAutocomplete
            label="Evento"
            tabindex="2"
            placeholder="Selecione o Evento"
            :loading="detailedSalesByEventLoading"
            clearable
            :disabled="storeSequencial === null"
            @click:clear="filter.payment = null"
            :items="allEvents"
            v-model="filter.product"
            item-text="descricao"
            item-value="descricao"
          >
            <template v-slot:selection="{ item }">
              <div v-if="item ? (produtos = item) : null">
                {{ item.descricao }}
              </div>
            </template>
          </BaseAutocomplete>
        </v-col>

        <v-col cols="12" md="3" sm="4" v-if="isAdmin">
          <BaseSelect
            label="Regional"
            tabindex="3"
            :items="regionais"
            data-cy="regional"
            loader-height="5"
            v-model="filter.regional"
            item-text="nome"
            item-value="idregional"
            placeholder="Selecione a Regional"
            clearable
            @click:clear="filter.regional = null"
          />
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <BaseSelect
            label="Forma de Pagamento"
            tabindex="6"
            :items="paymentMethods"
            v-model="filter.payment"
            item-text="key"
            item-value="value"
            placeholder="Selecione a Forma de Pagamento"
            clearable
            @click:clear="filter.payment = null"
          />
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <BaseSelect
            tabindex="5"
            label="Canal de Venda"
            :items="channelSales"
            v-model="filter.channel"
            item-text="value"
            item-value="key"
            placeholder="Selecione o Canal de Venda"
            clearable
            @click:clear="filter.channel = null"
          />
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu"
            v-model="menu"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Inicial"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.initDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.initDate"
              :active-picker.sync="activePicker"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu2"
            v-model="menu2"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Final"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.endDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.endDate"
              :active-picker.sync="activePicker2"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save2"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                readonly
                label="Hora Inicial"
                placeholder="hh:mm"
                append-icon="mdi-clock-outline"
                v-on="on"
                v-bind="attrs"
                v-mask="'##:##'"
                v-model="filter.initHour"
                :validate-on-blur="false"
              >
              </BaseTextField>
            </template>
            <v-time-picker
              v-model="filter.initHour"
              :active-picker.sync="activePicker3"
              @change="save3"
              locale="pt"
              scrollable
              format="24hr"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              range
            >
            </v-time-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                readonly
                placeholder="hh:mm"
                label="Hora Final"
                v-bind="attrs"
                v-on="on"
                v-mask="'##:##'"
                append-icon="mdi-clock-outline"
                v-model="filter.endHour"
                :validate-on-blur="false"
              >
              </BaseTextField>
            </template>
            <v-time-picker
              v-model="filter.endHour"
              :active-picker.sync="activePicker4"
              @change="save4"
              locale="pt"
              format="24hr"
              scrollable
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              range
            >
            </v-time-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex justify-end">
          <BaseButton
            tabindex="13"
            variant="filter"
            class="button rounded-xxl"
            type="submit"
            :loading="detailedSalesByEventLoading"
          >
            Filtrar
          </BaseButton>
        </v-col>
      </v-row>
    </v-form>

    <v-data-table
      class="rounded-lg"
      no-data-text="Não há registros."
      loading-text="Buscando informações...."
      :loading="detailedSalesByEventLoading"
      :headers="headers"
      :items="allDetailedSalesByEvent.info"
      :items-per-page="10"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Produtos por página:',
      }"
    >
      <template v-slot:item.valor="{ item }">
        {{ item.valor | moeda }}
      </template>
      <template v-slot:item.valor_item="{ item }">
        {{ item.valor_item | moeda }}
      </template>
      <template v-slot:item.valor_juros="{ item }">
        {{ item.valor_juros | moeda }}
      </template>
      <template v-slot:item.valor_cancelado="{ item }">
        {{ item.valor_cancelado | moeda }}
      </template>
      <template v-slot:item.valor_desconto="{ item }">
        {{ item.valor_desconto | moeda }}
      </template>
      <template v-slot:item.valor_total="{ item }">
        {{ item.valor_total | moeda }}
      </template>
    </v-data-table>
    <v-data-table
      class="rounded-lg"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
      }"
      hide-default-footer
      no-data-text="Não há registros."
      loading-text="Buscando informações..."
      :loading="detailedSalesByEventLoading"
      :headers="headersTotais"
      :items="allDetailedSalesByEvent.totals"
    >
      <template v-slot:item.valor="{ item }">
        {{ item.valor | moeda }}
      </template>
      <template v-slot:item.valor_juros="{ item }">
        {{ item.valor_juros | moeda }}
      </template>
      <template v-slot:item.valor_desconto="{ item }">
        {{ item.valor_desconto | moeda }}
      </template>
      <template v-slot:item.valor_cancelado="{ item }">
        {{ item.valor_cancelado | moeda }}
      </template>
      <template v-slot:item.valor_total="{ item }">
        {{ item.valor_total | moeda }}
      </template>
      <template v-slot:item.taxa_conveniencia="{ item }">
        {{ item.taxa_conveniencia | moeda }}
      </template>
      <template v-slot:item.taxa_processamento="{ item }">
        {{ item.taxa_processamento | moeda }}
      </template>
    </v-data-table>
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
export default {
  name: "GeneralAnalytical",
  metaInfo: {
    title:
      "Relatório Analítico de Venda Detalhada por Ingresso | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content:
          "Relatório Analítico de Venda Detalhada por Ingresso | ElevenTickets",
      },
    ],
  },
  props: {},
  components: { BaseSelect, BaseTextField, BaseAutocomplete, BaseButton },
  data() {
    return {
      filter: {
        product: null,
        regional: null,
        channel: null,
        payment: null,
        initDate: "",
        initDateView: "",
        endDate: "",
        endDateView: "",
        initHour: "",
        endHour: "",
      },
      tab: null,
      dayjs: dayjs,
      activePicker: null,
      activePicker2: null,
      activePicker3: null,
      activePicker4: null,
      date: null,
      hour: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      horaInicial: null,
      horaFinal: null,
      produtos: [],
      headers: [
        {
          text: "Produto",
          align: "center",
          sortable: false,
          value: "desc_produto",
          width: 200,
        },
        {
          text: "Pedidos",
          align: "center",
          value: "qtd_pedido",
          width: 90,
        },
        {
          text: "Itens",
          align: "center",
          value: "qtd_itens_pedido",
          width: 90,
        },
        {
          text: "Unitário",
          align: "center",
          value: "valor_item",
          width: 120,
        },
        {
          text: "Total",
          align: "center",
          value: "valor",
          width: 120,
        },
        {
          text: "Juros",
          align: "center",
          value: "valor_juros",
          width: 100,
        },
        {
          text: "Valor Cancelado",
          align: "center",
          value: "valor_cancelado",
          width: 140,
        },
        {
          text: "Desconto",
          align: "center",
          value: "valor_desconto",
          width: 120,
        },
        {
          text: "Total Geral",
          align: "center",
          value: "valor_total",
          width: 130,
        },
      ],
      headersTotais: [
        {
          text: "Total de Pedidos",
          align: "center",
          sortable: false,
          value: "qtd_pedido",
          width: 160,
        },
        {
          text: "Total de Itens",
          align: "center",
          sortable: false,
          value: "qtd_itens_pedido",
          width: 100,
        },
        {
          text: "Valor",
          align: "center",
          sortable: false,
          value: "valor",
          width: 160,
        },
        {
          text: "Total Taxa de Conveniência",
          align: "center",
          sortable: false,
          value: "taxa_conveniencia",
          width: 190,
        },
        {
          text: "Total Taxa de Processamento",
          align: "center",
          sortable: false,
          value: "taxa_processamento",
          width: 190,
        },
        {
          text: "Total de Juros",
          align: "center",
          sortable: false,
          value: "valor_juros",
          width: 160,
        },
        {
          text: "Total Cancelado",
          align: "center",
          sortable: false,
          value: "valor_cancelado",
          width: 160,
        },
        {
          text: "Total de Desconto",
          align: "center",
          sortable: false,
          value: "valor_desconto",
          width: 140,
        },
        {
          text: "Total",
          align: "center",
          sortable: false,
          value: "valor_total",
          width: 140,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "allDetailedSalesByEvent",
      "detailedSalesByEventLoading",
      "paymentMethods",
      "channelSales",
      "allEvents",
      "isAdmin",
      "regionais",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchDetailedSalesByEvent",
      "fetchPaymentMethodOptions",
      "fetchChannelSalesOptions",
      "fetchEvents",
      "fetchRegionais",
    ]),
    ...mapMutations(["setDetailedSalesByEventLoading", "setReportsFilter"]),
    filterDetailedSalesByEvent() {
      this.setDetailedSalesByEventLoading(true);
      let filter = {};

      if (this.filter.initDateView) {
        Object.assign(filter, {
          dthr_ped_ini: `${this.filter.initDate} ${this.filter.initHour}`,
        });
      }

      if (this.filter.endDateView) {
        Object.assign(filter, {
          dthr_ped_fim: `${this.filter.endDate} ${this.filter.endHour}`,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        dsc_produto: this.filter.product,
        idregional: this.filter.regional,
        canal_venda: this.filter.channel,
        forma_pagamento: this.filter.payment,
      });

      this.setReportsFilter(filter);
      this.fetchDetailedSalesByEvent(filter);
    },
    save(date) {
      this.$refs.menu.save(date);
      this.filter.initDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.filter.endDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save3(hour) {
      this.$refs.menu3.save(hour);
      this.filter.initHour = hour;
    },
    save4(hour) {
      this.$refs.menu4.save(hour);
      this.filter.endHour = hour;
    },
  },
  watch: {
    "$store.getters.storeSequencial": function () {
      this.fetchEvents({ producerId: this.storeSequencial });
      this.filterDetailedSalesByEvent();
    },
    "filter.initDate"() {
      this.filter.initHour = "00:00";
      this.filter.endHour = "23:59";
    },
    "filter.endDate"() {
      this.filter.initHour = "00:00";
      this.filter.endHour = "23:59";
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "HOUR"));
    },
    menu4(val) {
      val && setTimeout(() => (this.activePicker4 = "HOUR"));
    },
  },
  mounted() {
    this.filterDetailedSalesByEvent();
    this.fetchPaymentMethodOptions();
    this.fetchChannelSalesOptions();
    this.fetchRegionais();
    if (this.storeSequencial) {
      this.fetchEvents({ producerId: this.storeSequencial });
    }
  },
  destroyed() {
    this.filter = {
      product: null,
      regional: null,
      channel: null,
      payment: null,
      initDate: "",
      initDateView: "",
      endDate: "",
      endDateView: "",
      initHour: "",
      endHour: "",
    };
  },
};
</script>
<style scoped></style>
